// src/pages/fake.js
import React, { useMemo } from "react";
import { Link } from "react-router-dom";
import { useLanguage } from "../contexts/LanguageContext";
import { translations, artworks as artworksData } from "../data/mock";
import "../styles/portfolio.css";

const FakePage = () => {
  const { language, t } = useLanguage();

  const norm = (s = "") =>
    String(s)
      .normalize("NFD")
      .replace(/\p{Diacritic}/gu, "")
      .toLowerCase();

  const isFake = (w) => {
    const cats = Array.isArray(w?.categories)
      ? w.categories
      : [w?.category].filter(Boolean);
    return cats.map(norm).includes("fake");
  };

  const getSortKey = (w) => {
    if (w?.date) {
      const ts = Date.parse(w.date);
      if (!Number.isNaN(ts)) return ts;
    }
    if (typeof w?.episode === "number") return w.episode;
    if (typeof w?.year === "number") return w.year;
    const idNum = Number(w?.id);
    return Number.isNaN(idNum) ? 0 : idNum;
  };

  const fakeWorks = useMemo(() => {
    return (artworksData || [])
      .filter(isFake) // SOLO fake
      .sort((a, b) => getSortKey(b) - getSortKey(a)); // recenti -> vecchie
  }, [artworksData]);

  return (
    <div className="page-offset">
      <section className="section-spacing">
        <div className="container">
          <div className="fake-hero-images">
            <div className="fake-hero-image">
              <img
                src="/media/fake/fake-corridoio-uffici-1.jpg"
                alt={t({
                  it: "Stampe F.A.K.E. esposte nel corridoio di un ufficio",
                  en: "F.A.K.E. prints displayed in an office corridor",
                })}
              />
            </div>
            <div className="fake-hero-image">
              <img
                src="/media/fake/fake-corridoio-uffici-2.jpg"
                alt={t({
                  it: "Seconda ambientazione delle stampe F.A.K.E. in un corridoio",
                  en: "Second setting of F.A.K.E. prints in a corridor",
                })}
              />
            </div>
          </div>

          {/* titolo + intro */}
          <div style={{ maxWidth: 900, margin: "0 auto 24px" }}>
            <h1 className="section-title" style={{ marginBottom: "var(--spacing-md)" }}>
              F.A.K.E. - Fragments About Knowing Everything
            </h1>

            <p className="body-text" style={{ marginBottom: 0 }}>
  {t({
    it: "F.A.K.E. (Fragments About Knowing Everything) è un progetto che lavora sull’appropriazione di immagini iconiche dell’arte e della storia, ricostruite come falsi consapevoli. Non per imitare l’originale, ma per metterlo in crisi nel presente. Un’immagine riconoscibile, ma spostata quanto basta perché smetta di funzionare come prima. Il falso diventa strumento per interrogare ciò che oggi appare normale, accettato, inevitabile.",
    en: "F.A.K.E. (Fragments About Knowing Everything) is a project that works through the appropriation of iconic images from art and history, reconstructed as conscious fakes. Not to imitate the original, but to destabilize it in the present. A recognizable image, shifted just enough to stop functioning as it did before. The fake becomes a tool to question what today appears normal, accepted, inevitable.",
  })}
</p>

<p className="body-text" style={{ marginTop: "1.5em", marginBottom: 0 }}>
  {t({
    it: "Le opere del progetto F.A.K.E. sono disponibili come stampe Fine Art in edizione limitata, numerate e firmate, realizzate in formati variabili.",
    en: "The works in the F.A.K.E. project are available as limited-edition Fine Art prints, numbered and signed, in variable formats.",
  })}
</p>
          </div>

          {/* GRIGLIA come Opere (2 per riga) */}
          <div className="grid-3">
            {fakeWorks.map((work, index) => (
              <div
                key={work.id}
                className="artwork-card fade-in-up"
                style={{ animationDelay: `${index * 0.05}s` }}
              >
                <Link to={`/${language}/works/${work.id}`}>
                  <div className="image-box">
                    <img
                      src={work.image}
                      alt={t(work.title)}
                      className="artwork-image"
                      onError={(e) => {
                        e.currentTarget.src = "/media/placeholder.jpg";
                      }}
                    />
                  </div>

                  <div className="artwork-info">
                    <h3 className="artwork-title">{t(work.title)}</h3>

                    <div className="artwork-meta">
                      <span className="small-text">{work.year}</span>
                      <span className="category-badge">F.A.K.E.</span>
                    </div>
                  </div>
                </Link>
              </div>
            ))}
          </div>

          {fakeWorks.length === 0 && (
            <div style={{ textAlign: "center", padding: "var(--spacing-3xl)" }}>
              <p className="body-text">
                {t({ it: "Nessuna opera F.A.K.E. trovata.", en: "No F.A.K.E. works found." })}
              </p>
            </div>
          )}
        </div>
      </section>
    </div>
  );
};

export default FakePage;
